import { useSelector } from 'react-redux';
import { projectColors as selectProjectColors } from 'spw-redux/modules/projects/selectors';
import { ALL_CATEGORIES } from 'spw-esa-projects/building-details/occupancy-and-utilization/cards/constants';
import { colors } from 'spw-theme';

export const useCategoryColor = (category: string): string => {
  const projectColors = useSelector(selectProjectColors);
  if (category === ALL_CATEGORIES) return colors.mainGray;
  return projectColors[category] as string;
};
